import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import propLoaders from '../../../prop-loaders';
import {getLanguageCode, getTranslations} from '../../../utils/selectors';
import Spinner from '../../atoms/Spinner';
import {useAdyenStatusWaiting} from './adyen-status-waiting.hooks';

const AdyenStatusWaiting = ({
    dispatch,
    languageCode,
    initData,
    initError,
    match: {
        params: {
            paymentSessionId
        }
    }
}) => {
    useAdyenStatusWaiting({
        paymentSessionId,
        languageCode,
        dispatch,
        initData,
        initError
    });

    return (
        <div className="main-spinner">
            <Spinner />
        </div>
    );
};


AdyenStatusWaiting.getServerSideProps = async ({
    requestId,
    sessionId,
    params: {
        paymentSessionId
    },
    query: {
        resultCode
    }
}) => {
    try {
        const initData = await propLoaders.getAdyenStatus(
            {requestId, sessionId, query: {paymentSessionId, resultCode}}
        );
        return {
            initData
        };
    } catch (error) {
        return {
            initError: error
        };
    }
};

AdyenStatusWaiting.propTypes = {
    initData: PropTypes.shape({
        paymentStatus: PropTypes.string.isRequired,
        redirectUrl: PropTypes.string
    }),
    initError: PropTypes.number,
    match: PropTypes.shape({
        params: PropTypes.shape({
            paymentSessionId: PropTypes.string.isRequired,
            language: PropTypes.string.isRequired
        }).isRequired
    }).isRequired
};

AdyenStatusWaiting.defaultProps = {
    initData: undefined,
    initError: null
};

const mapStateToProps = state => ({
    languageCode: getLanguageCode(state),
    translations: getTranslations(state)
});

export default connect(mapStateToProps)(AdyenStatusWaiting);
